<template>
  <v-container fluid class="pa-4 pf-page">
    <SidebarNavigation />

    <!-- HEADER -->
    <v-card
      flat
      rounded="xl"
      class="mb-4 px-4 py-3 d-flex align-center justify-space-between flex-wrap"
    >
      <!-- <v-col cols="12" md="3" class="pa-0 mt-3 mt-md-0">
        <v-select
          v-model="fiscalYear"
          :items="listFiscalYear"
          label="Tahun"
          prepend-inner-icon="mdi-calendar"
          dense
          outlined
          rounded
          clearable
          hide-details
          background-color="white"
          @change="updateQuery('fiscalYear', fiscalYear)"
        />
      </v-col> -->
    </v-card>

    <!-- TABLE -->
    <v-card rounded="xl" class="elevation-3 overflow-hidden">
      <v-data-table
        mobile-breakpoint="0"
        dense
        hide-default-footer
        disable-pagination
        class="pf-table"
        :headers="tableHeaders"
        :items="list"
        item-key="id"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <!-- ROW DATA -->
            <tr v-for="item in items" :key="item.id">
              <!-- JAN -->
              <td class="text-center">
                <v-switch
                  v-model="item.jan"
                  :true-value="1"
                  :false-value="null"
                  inset
                  dense
                  hide-details
                  color="success"
                  @change="submitUpdate(item, 'jan')"
                />
              </td>

              <!-- FEB -->
              <td class="text-center">
                <v-switch
                  v-model="item.feb"
                  :true-value="1"
                  :false-value="null"
                  inset
                  dense
                  hide-details
                  color="success"
                  @change="submitUpdate(item, 'feb')"
                />
              </td>

              <!-- MAR -->
              <td class="text-center">
                <v-switch
                  v-model="item.mar"
                  :true-value="1"
                  :false-value="null"
                  inset
                  dense
                  hide-details
                  color="success"
                  @change="submitUpdate(item, 'mar')"
                />
              </td>

              <!-- APR -->
              <td class="text-center">
                <v-switch
                  v-model="item.apr"
                  :true-value="1"
                  :false-value="null"
                  inset
                  dense
                  hide-details
                  color="success"
                  @change="submitUpdate(item, 'apr')"
                />
              </td>

              <!-- MEI -->
              <td class="text-center">
                <v-switch
                  v-model="item.mei"
                  :true-value="1"
                  :false-value="null"
                  inset
                  dense
                  hide-details
                  color="success"
                  @change="submitUpdate(item, 'mei')"
                />
              </td>

              <!-- JUN -->
              <td class="text-center">
                <v-switch
                  v-model="item.jun"
                  :true-value="1"
                  :false-value="null"
                  inset
                  dense
                  hide-details
                  color="success"
                  @change="submitUpdate(item, 'jun')"
                />
              </td>

              <!-- JUL -->
              <td class="text-center">
                <v-switch
                  v-model="item.jul"
                  :true-value="1"
                  :false-value="null"
                  inset
                  dense
                  hide-details
                  color="success"
                  @change="submitUpdate(item, 'jul')"
                />
              </td>

              <!-- AGS -->
              <td class="text-center">
                <v-switch
                  v-model="item.ags"
                  :true-value="1"
                  :false-value="null"
                  inset
                  dense
                  hide-details
                  color="success"
                  @change="submitUpdate(item, 'ags')"
                />
              </td>

              <!-- SEP -->
              <td class="text-center">
                <v-switch
                  v-model="item.sep"
                  :true-value="1"
                  :false-value="null"
                  inset
                  dense
                  hide-details
                  color="success"
                  @change="submitUpdate(item, 'sep')"
                />
              </td>

              <!-- OKT -->
              <td class="text-center">
                <v-switch
                  v-model="item.okt"
                  :true-value="1"
                  :false-value="null"
                  inset
                  dense
                  hide-details
                  color="success"
                  @change="submitUpdate(item, 'okt')"
                />
              </td>

              <!-- NOV -->
              <td class="text-center">
                <v-switch
                  v-model="item.nov"
                  :true-value="1"
                  :false-value="null"
                  inset
                  dense
                  hide-details
                  color="success"
                  @change="submitUpdate(item, 'nov')"
                />
              </td>

              <!-- DES -->
              <td class="text-center">
                <v-switch
                  v-model="item.des"
                  :true-value="1"
                  :false-value="null"
                  inset
                  dense
                  hide-details
                  color="success"
                  @change="submitUpdate(item, 'des')"
                />
              </td>

              <!-- TOTAL -->
              <td class="text-center">
                <v-chip small color="primary" dark class="font-weight-bold">
                  {{ item.qty }}
                </v-chip>
              </td>
            </tr>

            <!-- TOTAL ROW -->
            <tr class="summary-row">
              <td class="text-center">
                {{ items.filter((v) => v.jan == 1).length }}
              </td>

              <td class="text-center">
                {{ items.filter((v) => v.feb == 1).length }}
              </td>

              <td class="text-center">
                {{ items.filter((v) => v.mar == 1).length }}
              </td>

              <td class="text-center">
                {{ items.filter((v) => v.apr == 1).length }}
              </td>

              <td class="text-center">
                {{ items.filter((v) => v.mei == 1).length }}
              </td>

              <td class="text-center">
                {{ items.filter((v) => v.jun == 1).length }}
              </td>

              <td class="text-center">
                {{ items.filter((v) => v.jul == 1).length }}
              </td>

              <td class="text-center">
                {{ items.filter((v) => v.ags == 1).length }}
              </td>

              <td class="text-center">
                {{ items.filter((v) => v.sep == 1).length }}
              </td>

              <td class="text-center">
                {{ items.filter((v) => v.okt == 1).length }}
              </td>

              <td class="text-center">
                {{ items.filter((v) => v.nov == 1).length }}
              </td>

              <td class="text-center">
                {{ items.filter((v) => v.des == 1).length }}
              </td>

              <td class="text-center">
                {{
                  items.reduce((total, item) => {
                    return (
                      total +
                      [
                        item.jan,
                        item.feb,
                        item.mar,
                        item.apr,
                        item.mei,
                        item.jun,
                        item.jul,
                        item.ags,
                        item.sep,
                        item.okt,
                        item.nov,
                        item.des,
                      ].filter((v) => v == 1).length
                    );
                  }, 0)
                }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>

    <snackbarMessage />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";
import { getCurrentYear } from "@/utils/date";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    return {
      tabItems: ["UOM"],
      isLoading: false,
      search: "",
      tab: 1,
      tableHeaders: [
        { text: "Januari", align: "center", value: "jan" },
        { text: "Februari", align: "center", value: "feb" },
        { text: "Maret", align: "center", value: "mar" },
        { text: "April", align: "center", value: "apr" },
        { text: "Mei", align: "center", value: "mei" },
        { text: "Juni", align: "center", value: "jun" },
        { text: "Juli", align: "center", value: "jul" },
        { text: "Agustus", align: "center", value: "AGS" },
        { text: "September", align: "center", value: "sep" },
        { text: "Oktober", align: "center", value: "okt" },
        { text: "November", align: "center", value: "nov" },
        { text: "Desember", align: "center", value: "des" },
        { text: "Jumlah", align: "center", value: "jumlah" },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: true,
        search: "",
      },
      total: null,
      list: [],
      isDialogOpenEdit: false,
      isDialogOpenDelete: false,
      isFormValidUpdate: false,

      selectedItem: null,
      id: null,
    };
  },
  methods: {
    fetch() {
      store.dispatch("showLoading");
      const query = this.$route.query;
      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: -1,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "name",
        sortDesc: query.sortDesc || this.pagination.sortDesc || false,
        startDate: query.startDate || this.startDate,
        endDate: query.endDate || this.endDate,
        fiscalYear: getCurrentYear() + 1,
      };

      api
        .get("/pf", { params })
        .then(({ data }) => {
          this.list = data.data.data;
          this.total = data.data.total;
        })
        .catch((error) => {
          console.error("Error fetching parameters:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    submitUpdate(item, field) {
      store.dispatch("showLoading");

      // simpan value sebelumnya untuk rollback
      const oldValue = item[field] == 1 ? 1 : null;

      const payload = {
        id: item.id,
        month: field,
        value: item[field],
      };

      api
        .post("/pf/update", payload)
        .then((response) => {
          const message = response.data.message;

          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: true,
          });
        })
        .catch((error) => {
          // rollback jika gagal
          item[field] = oldValue;

          let message = "Gagal update data!";

          if (error.response) {
            message = error.response.data.message || message;
          } else {
            message = error.message || message;
          }

          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.fetch();
          store.dispatch("hideLoading");
        });
    },

    debouncedSearch() {
      this.updateQuery("search", this.pagination.search);
    },
    updatePagination(query) {
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.selectedDivisionId = parseInt(query.divisionId) || 0;
      this.selectedPositionId = parseInt(query.positionId) || 0;
      this.selectedSiteId = parseInt(query.siteId) || 0;
      this.fiscalYear = parseInt(query.fiscalYear) || getCurrentYear();
    },
    updateQuery(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },
  },
  mounted() {
    store.commit("setTitle", "Frekuensi Pembelian");
    this.updatePagination(this.$route.query);
  },
  watch: {
    pagination: {
      handler: "fetch",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
    fiscalYear: {
      handler: "fetch",
    },
  },
};
</script>

<style scoped>
.pf-page {
  background: #f5f7fb;
  min-height: 100vh;
}

/* wrapper scroll */
.table-wrapper {
  max-height: 650px;
  overflow-y: auto;
  overflow-x: auto;
}

.pf-table ::v-deep thead th {
  background: white !important;
  font-weight: 700 !important;
  font-size: 13px !important;
  color: #374151 !important;
  border-bottom: 1px solid #e5e7eb !important;
  white-space: nowrap;
}

/* hover row */
.pf-table ::v-deep tbody tr:hover {
  background: #f9fafb !important;
}

/* rapikan switch */
.pf-table ::v-deep .v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
  justify-content: center;
}

/* sticky summary row */
.summary-row {
  /* position: sticky; */
  bottom: 0;
  z-index: 15;
  background: #eef2ff !important;
  font-weight: 700;
  border-top: 2px solid #c7d2fe;
}

.summary-row td {
  color: #1e3a8a;
  background: #eef2ff !important;
}
</style>
